
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/software/gestao-de-obra/elaborar-e-gerir-os-trabalhos-a-mais",
      function () {
        return require("private-next-pages/software/gestao-de-obra/elaborar-e-gerir-os-trabalhos-a-mais.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/software/gestao-de-obra/elaborar-e-gerir-os-trabalhos-a-mais"])
      });
    }
  